import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import CookService from '../../services/cook.service';

const useStyles = makeStyles((theme) => ({
  panel: { padding: theme.spacing(1.5, 2), marginBottom: theme.spacing(2) },
  header: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: theme.spacing(1), marginBottom: theme.spacing(1) },
  status: { color: '#888', fontSize: 12 },
  error: { color: '#c62828', fontSize: 12 }
}));

// Editable notes for a cook: vent changes, how the pit behaved, what you'd do
// differently. Saved explicitly; the button only lights up when there are changes.
const CookNotes = ({ cookId, notes }) => {
  const classes = useStyles();
  const [text, setText] = useState(notes || '');
  const [saved, setSaved] = useState(notes || '');
  const [status, setStatus] = useState(null); // {error, text}

  useEffect(() => { setText(notes || ''); setSaved(notes || ''); }, [cookId, notes]);

  const dirty = text.trim() !== saved.trim();

  const save = () => {
    CookService.saveNotes(cookId, text)
      .then(res => { setSaved(res.data.notes || ''); setStatus({ text: 'Saved' }); })
      .catch(err => setStatus({ error: true, text: err.response?.data?.message || 'Could not save notes.' }));
  };

  return (
    <Paper className={classes.panel}>
      <div className={classes.header}>
        <Typography variant="subtitle1">Notes</Typography>
        <div>
          {status && !dirty && <span className={status.error ? classes.error : classes.status}>{status.text}</span>}
          {dirty && <span className={classes.status}>Unsaved changes </span>}
          <Button size="small" color="primary" variant="outlined" disabled={!dirty} onClick={save}>Save</Button>
        </div>
      </div>
      <TextField
        multiline rows={3} rowsMax={16} fullWidth variant="outlined" size="small"
        placeholder="Vent changes, how the pit behaved, doneness, what to do next time…"
        value={text}
        onChange={e => { setText(e.target.value); setStatus(null); }}
        inputProps={{ maxLength: 10000, 'aria-label': 'Cook notes' }} />
    </Paper>
  );
};

export default CookNotes;
